import TaskList from "../../interfaces/task/TaskList";

export interface TaskSearchQuery {
    searchTerm?: string;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDesc?: boolean;
}

export interface TaskSearchResult {
    tasks: TaskList[];
    totalCount: number;
}

export async function searchTasks(
    authToken: string,
    query: TaskSearchQuery
): Promise<TaskSearchResult | null> {
    const { searchTerm, page, pageSize, sortBy, sortDesc } = query;
    const params = new URLSearchParams();
    if (searchTerm) params.append("searchTerm", searchTerm);
    if (page) params.append("page", page.toString());
    if (pageSize) params.append("pageSize", pageSize.toString());
    if (sortBy) params.append("sortBy", sortBy);
    if (sortDesc) params.append("sortDesc", sortDesc.toString());

    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/search/task?${params.toString()}`;

    try {
        const response = await fetch(apiUrl, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${authToken}`,
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            console.error("Failed to search tasks:", response.statusText);
            return null;
        }

        const json = await response.json();
        return json as TaskSearchResult;
    } catch (err) {
        console.error("Error searching tasks:", err);
        return null;
    }
}
